import { useState } from 'react';

const useLocalStorage = <T>(key: string, initialValue: T) => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      if (item !== null) {
        if (['{', '['].includes(item[0])) {
          return JSON.parse(item);
        }
        if (['true', 'false'].includes(item)) {
          return item === 'true';
        }
        return item;
      }
      return initialValue;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  });

  const setValue = (value: T | ((val: T) => T)) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);

      const isObjectOrArray = typeof valueToStore === 'object' && valueToStore !== null;

      const vToStore = isObjectOrArray ? JSON.stringify(valueToStore) : String(valueToStore);

      window.localStorage.setItem(key, vToStore);
    } catch (error) {
      console.error(error);
    }
  };

  const removeValue = () => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.error(error);
    }
  };
  return [storedValue, setValue, removeValue] as const;
};

export default useLocalStorage;
